var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.isFullscreen?'icon-tuichuquanping':'icon-quanping','ali-iconfont'],on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }